module.exports = __webpack_public_path__ + "static/media/blurred-city.74b738da.png";